import config from './config';

// Base URL is now configured via environment variables
// See .env.development and .env.production files
export const BASE_URL = config.apiBaseUrl;

// Payment types
export const ON_ACCOUNT = 'ON_ACCOUNT' as const;
export const VERIFY_PAYMENT = 'VERIFY_PAYMENT' as const;
export const CREDIT_CARD = 'CREDIT_CARD' as const;

// Booking statuses
export const ACCEPTED = 'ACCEPTED' as const;
export const AWAITING_ACTION = 'AWAITING_ACTION' as const;
export const DECLINED = 'DECLINED' as const;
export const CANCELLED = 'CANCELLED' as const;

// Type exports
export type PaymentTypeValue = typeof ON_ACCOUNT | typeof VERIFY_PAYMENT | typeof CREDIT_CARD;
export type BookingStatusValue = typeof ACCEPTED | typeof AWAITING_ACTION | typeof DECLINED | typeof CANCELLED;
